const insuranceBalanceNoteReducer = (state = 'Your Updated Balance without Travel Insurance:', action) => {
	switch(action.type){
	case 'UPDATEINSURANCENOTE':
		return action.payload;
	default:
		return state;
	}
}

export default insuranceBalanceNoteReducer;
